
const { kebabCase } = require('lodash')

module.exports = (name, { connected, stateless, props=[] }={}) => {
	let result = ''

	result += "import React from 'react'"

	result += "\nimport PropTypes from 'prop-types'"

	result += connected ?
		"\nimport { connect } from 'react-redux'" : ""

	result += "\n\n\n"


	result += stateless ?
`const ${name} = props => {
		return (
				<div className="${kebabCase(name)}">
						<p>{props.name}</p>
				</div>
		)
}` :
`class ${name} extends React.Component {

		state = {
		    capitalize: false
		}

		handleNameClick = () => {
			this.setState(prevState => ({
				capitalize: !prevState.capitalize
			}))
		}

    render() {

				const name = this.state.capitalize ?
						this.props.name.toUpperCase() : this.props.name

        return (
            <div className="${kebabCase(name)}">
                <p onClick={this.handleNameClick}>{name}</p>
            </div>
        )
    }
}`

	result += "\n\n"

	result += `${name}.displayName = "${name}"`
	result += `${name}.defaultProps = {\n\tname: "${name}"\n}`

	result += "\n\n"

	result += `${name}.propTypes = {\n\tname: PropTypes.string\n}`

	result += "\n\n"

	result += connected ?
		`export default connect()(${name})` :
		`export default ${name}`

	return result

}



// WEBPACK FOOTER //
// ./src/templates/component_jsx.js